	/**
 * @link https://span.studio
 * @copyright Copyright (c) Span Studio LLC
 * @license https://github.com/Span-Studio/sta100-craft5/blob/main/LICENSE.md
 * 
 * Modal.
 * UI for displaying confirmation pop-up modals.
 * 
 * @author John Pobojewski <https://john.pobojewski.com
 */

class Modal {
	constructor() {
		this.dismissTimer = false;
	}

	init() {
		console.log("Modal.init()");
		const q = this.get_queries();
		if (q && typeof ModalAlertMessages !== "undefined") this.alert(q);
	}

	alert(messages) {
		console.log("Modal.alert()");
		for (let m = 0; m < messages.length; m++) {
			const output = this.process_message(messages[m]);
			if (output) this.build(output, false, null);
		}
	}

	processing(message=false) {
		console.log("Modal.processing()");
		let output = "";
		if (message != false) output += "<p class='margin-bottom'>" + message + "</p>";
		output += "<span class='spinner'><span></span></span>";

		this.build(output, false, null);
	}

	build(message, buttons, callback) {
		console.log("Modal.build()");

		// Remove existing modals
		document.querySelectorAll('#modal-container .modal').forEach(el => el.remove());

		const container = document.getElementById('modal-container');

		if (buttons) {
			const output = document.createElement('div');
			output.className = 'modal add-buttons';
			output.innerHTML = message;

			const buttonWrapper = document.createElement('div');

			const okBtn = document.createElement('button');
			okBtn.type = 'button';
			okBtn.dataset.action = 'accept';
			okBtn.textContent = 'Ok';

			const cancelBtn = document.createElement('button');
			cancelBtn.type = 'button';
			cancelBtn.dataset.action = 'cancel';
			cancelBtn.textContent = 'Cancel';

			buttonWrapper.appendChild(okBtn);
			buttonWrapper.appendChild(cancelBtn);
			output.appendChild(buttonWrapper);

			container.appendChild(output);

			okBtn.addEventListener('click', callback);
			cancelBtn.addEventListener('click', this.dismiss);
		} else {
			const output = document.createElement('div');
			output.className = 'modal';
			output.innerHTML = message;
			container.appendChild(output);
			this.dismissTimer = window.setTimeout(this.dismiss, 1500);
		}
	}

	dismiss() {
		console.log("Modal.dismiss()");
		document.querySelectorAll('.modal').forEach(modal => {
			modal.style.transition = 'opacity 0.3s ease';
			modal.style.opacity = '0';
			setTimeout(() => modal.remove(), 300);
		});
		if (this.dismissTimer) window.clearTimeout(this.dismissTimer);

		if (window.location.href.indexOf('?') > -1) {
			history.pushState('', document.title, window.location.pathname);
		}
	}

	get_queries() {
		const vars = [];
		const hashIndex = window.location.href.indexOf('?');
		if (hashIndex === -1) return vars;

		const hashes = window.location.href.slice(hashIndex + 1).split('&');
		for (let i = 0; i < hashes.length; i++) {
			const hash = hashes[i].split('=');
			vars.push({ query: hash[0], value: hash[1] });
		}
		return vars;
	}

	process_message(input) {
		for (let m = 0; m < ModalAlertMessages.length; m++) {
			const q = ModalAlertMessages[m].query;
			const v = input.value;
			if (q === v) return ModalAlertMessages[m].message;
		}
	}

	interrupt(button, callback) {
		console.log("Modal.interrupt(): " + button.dataset.entryId);
		this.build("<p>This will delete this entry forever!<br/>Are you sure you want to do this?</p>", true, function() {
			callback(button);
		});
	}
}

export default new Modal();
